export default "__VITE_ASSET__DPytLyoT__"